import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@mui/material';
import { ButtonV2 } from 'components/common/ui';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { styles } from './servicePointContactsModal.styles';

export const ServicePointContactsModal = ({ open, onClose, contacts = [] }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={styles.dialogTitle}>
        <Typography sx={styles.title}>Contact Details</Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon sx={styles.closeIcon} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={styles.section}>
          <Box sx={styles.sectionHeader}>
            <Typography sx={styles.sectionTitle}>
              Contact Persons Primary:
            </Typography>
            <ButtonV2
              variant="text"
              size="small"
              startIcon={<AddIcon sx={styles.addButtonIcon} />}
            >
              Add Contact Person
            </ButtonV2>
          </Box>
          <RadioGroup>
            {contacts.map((contact) => (
              <Box
                key={contact.id || contact.email || Math.random()}
                sx={styles.contactItem}
              >
                <FormControlLabel
                  value={contact.id}
                  control={
                    <Radio
                      size="small"
                      checked={contact.isPrimary}
                      sx={styles.radio}
                    />
                  }
                  label={contact.fullName || contact.email || 'Unnamed'}
                  sx={styles.formControlLabel}
                />
                <IconButton size="small" sx={styles.deleteButton}>
                  <DeleteOutlineIcon sx={styles.deleteIcon} />
                </IconButton>
              </Box>
            ))}
          </RadioGroup>
        </Box>

        {/* Phones */}
        <Box sx={styles.section}>
          <Box sx={styles.sectionHeader}>
            <Typography sx={styles.sectionTitle}>Phones Primary:</Typography>
            <ButtonV2
              variant="text"
              size="small"
              startIcon={<AddIcon sx={styles.addButtonIcon} />}
            >
              Add Phone
            </ButtonV2>
          </Box>
          <RadioGroup>
            {contacts.map((contact) => {
              const phoneNumber = contact?.phoneNumber?.phoneNumber;
              if (!phoneNumber) return null;
              return (
                <Box
                  key={`phone-${contact.id || phoneNumber}`}
                  sx={styles.contactItem}
                >
                  <FormControlLabel
                    value={contact.id}
                    control={
                      <Radio
                        size="small"
                        checked={contact.isPrimary}
                        sx={styles.radio}
                      />
                    }
                    label={phoneNumber}
                    sx={styles.formControlLabel}
                  />
                  <IconButton size="small" sx={styles.deleteButton}>
                    <DeleteOutlineIcon sx={styles.deleteIcon} />
                  </IconButton>
                </Box>
              );
            })}
          </RadioGroup>
        </Box>

        <Box>
          <Box sx={styles.sectionHeader}>
            <Typography sx={styles.sectionTitle}>Emails Primary:</Typography>
            <ButtonV2
              variant="text"
              size="small"
              startIcon={<AddIcon sx={styles.addButtonIcon} />}
            >
              Add Email
            </ButtonV2>
          </Box>
          <RadioGroup>
            {contacts.map((contact) => {
              if (!contact.email) return null;
              return (
                <Box
                  key={`email-${contact.id || contact.email}`}
                  sx={styles.contactItem}
                >
                  <FormControlLabel
                    value={contact.id}
                    control={
                      <Radio
                        size="small"
                        checked={contact.isPrimary}
                        sx={styles.radio}
                      />
                    }
                    label={contact.email}
                    sx={styles.formControlLabel}
                  />
                  <IconButton size="small" sx={styles.deleteButton}>
                    <DeleteOutlineIcon sx={styles.deleteIcon} />
                  </IconButton>
                </Box>
              );
            })}
          </RadioGroup>
        </Box>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <ButtonV2 variant="outlined" onClick={onClose}>
          Cancel
        </ButtonV2>
        <ButtonV2 onClick={onClose}>Save</ButtonV2>
      </DialogActions>
    </Dialog>
  );
};
